import styled from 'styled-components';

export const ScFaq = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 800px;
  width: 100%;
`;
